import { LanguageItem } from '@globalonmedia/ui-components/dist/types/components/df-language-selector/lang.types'

export const langLinks: LanguageItem[] = [
  {
    subdomain: 'dev',
    title: 'English',
    icon: 'en',
  },
  {
    subdomain: 'es-dev',
    title: 'Spanish',
    icon: 'es',
  },
  {
    subdomain: 'arab-dev',
    title: 'Arabic',
    icon: 'sa',
  },
  {
    subdomain: 'it-dev',
    title: 'Italian',
    icon: 'it',
  },
  {
    subdomain: 'fr-dev',
    title: 'French',
    icon: 'fr',
  },
  {
    subdomain: 'tr-dev',
    title: 'Turkish',
    icon: 'tr',
  },
  {
    subdomain: 'se-dev',
    title: 'Swedish',
    icon: 'se',
  },
  {
    subdomain: 'pl-dev',
    title: 'Polish',
    icon: 'pl',
  },
  {
    subdomain: 'de-dev',
    title: 'Deutsch',
    icon: 'de',
  },
  {
    subdomain: 'jp-dev',
    title: 'Japanese',
    icon: 'jp',
  },
]
